
import { ROW_HEIGHT, columns } from '../ClientsTableProperties';
import { useMemo } from 'external/react';
import useAdmin from 'context/admin-context/hook';

const ClientsTableFillerRow = () => {
  const { state } = useAdmin();
  const { items } = state.clients;
  const paging = state.clientsPaging;
  const pageSize = useMemo(() => paging ? paging.pageSize : 0, [paging]);
  if (items.length >= pageSize) return;
  return (
    <tr style={{ pointerEvents: 'none' }}>
      <td
        colSpan={columns.length}
        rowSpan={Math.max(0, pageSize - items.length)}
        style={{ border: 'none', height: `${(pageSize - items.length) * ROW_HEIGHT}px` }}
      />
    </tr>
  )
}

export default ClientsTableFillerRow;